var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhpstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M16 30 50 10h48l14 34-20 30-44 14-32-22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M28 18h56l28 28v54H58L28 70Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3bdc0",
    d: "M40 30h50l10 12-18 18-42 8-12-10Z",
    opacity: 0.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3bdc0",
    d: "M34 34h58v58H34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M43 85h21v4H43Zm18-27 3-4a10.8 10.8 0 0 0 7 2.8c2.1 0 3.4-.8 3.4-2.2v-.1c0-1.3-.8-2-4.8-3-4.7-1.2-7.7-2.5-7.7-7.1v-.1c0-4.2 3.4-7 8.2-7a13.5 13.5 0 0 1 8.7 3l-2.7 3.8a10.9 10.9 0 0 0-6.1-2.3c-2 0-3 .9-3 2.1v.1c0 1.5 1 2 5.1 3.1 4.7 1.2 7.4 2.9 7.4 7v.1c0 4.6-3.5 7.2-8.6 7.2A14.8 14.8 0 0 1 61 58Zm-18-20h9.5c5.5 0 8.9 3.3 8.9 8v.1c0 5.4-4.2 8.2-9.4 8.2h-3.8v7H43Zm9.1 11.7c2.6 0 4.1-1.5 4.1-3.5v-.1c0-2.3-1.6-3.5-4.2-3.5h-3.9v7.1Zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhpstorm);
export default __webpack_public_path__ + "static/media/phpstorm.f8ef8d8101fab3e57eea143968b22120.svg";
export { ForwardRef as ReactComponent };